import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changePageSize, changeSorting, changeViewType } from 'b2b-apps/shop/settings/redux/actionCreators';

type UseCatalogSettingsActionsReturnType = {
  changeViewType: typeof changeViewType;
  changePageSize: typeof changePageSize;
  changeSorting: typeof changeSorting;
};

const useCatalogSettingsActions = (): UseCatalogSettingsActionsReturnType => {
  const dispatch = useDispatch();

  return useMemo(() => bindActionCreators(
    {
      changeViewType,
      changePageSize,
      changeSorting,
    },
    dispatch,
  ), [dispatch]);
};

export type { UseCatalogSettingsActionsReturnType };
export { useCatalogSettingsActions };
